import { render, staticRenderFns } from "./MAMDetail.vue?vue&type=template&id=23973acd&scoped=true"
import script from "./MAMDetail.vue?vue&type=script&lang=js"
export * from "./MAMDetail.vue?vue&type=script&lang=js"
import style0 from "./MAMDetail.vue?vue&type=style&index=0&id=23973acd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23973acd",
  null
  
)

export default component.exports